import React, { ReactElement } from 'react';

import { Record } from '@yandex-360/iconostasis/dist/icons/Record';
import { Stop } from '@yandex-360/iconostasis/dist/icons/Stop';

import { States } from '../../../../../../../../helpers/audio-helper';

export const getInputDiagnosticBtnIcon = (state: States, isHovered = true): ReactElement | undefined => {
    switch (state) {
        case States.IDLE:
            return <Record variant="outline" size="sm" />;
        case States.RECORDING:
            return isHovered ? <Stop variant="solid" size="sm" /> : undefined;
        case States.PLAYING:
            return isHovered ? <Stop variant="solid" size="sm" /> : undefined;
        default:
            return undefined;
    }
};
